"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dialogActionsClassNames: ()=>dialogActionsClassNames,
    useDialogActionsStyles_unstable: ()=>useDialogActionsStyles_unstable
});
const _react = require("@griffel/react");
const dialogActionsClassNames = {
    root: 'fui-DialogActions'
};
const useStyles = /*#__PURE__*/ (0, _react["__styles"])({
    root: {
        Bqenvij: "f3052tw",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f22iagw",
        i8kkvl: "f4px1ci",
        Belr9w4: "fn67r4l",
        Bmdcpmo: "f6glcwc",
        th9wkt: "f1e3st1r"
    },
    gridPositionEnd: {
        Bdqf98w: "f1a7i8kp",
        Ijaq50: "f11u0jfc",
        Br312pm: "f1d6tb1o",
        nk6f5a: "f23awfp",
        Bw0ie65: "fiappcv"
    },
    gridPositionStart: {
        Bdqf98w: "fsxvdwy",
        Ijaq50: "f1vnb230",
        Br312pm: "f14781pt",
        nk6f5a: "f13d374e",
        Bw0ie65: "f1fjo411"
    },
    fluidStart: {
        Bw0ie65: "fiappcv"
    },
    fluidEnd: {
        Br312pm: "f14781pt"
    }
}, {
    d: [
        ".f3052tw{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f22iagw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}",
        ".f4px1ci{-webkit-column-gap:8px;column-gap:8px;}",
        ".fn67r4l{row-gap:8px;}",
        ".f1a7i8kp{justify-self:end;}",
        ".f11u0jfc{grid-row-start:actions-end;}",
        ".f1d6tb1o{grid-column-start:actions-end;}",
        ".f23awfp{grid-row-end:actions-end;}",
        ".fiappcv{grid-column-end:actions-end;}",
        ".fsxvdwy{justify-self:start;}",
        ".f1vnb230{grid-row-start:actions-start;}",
        ".f14781pt{grid-column-start:actions-start;}",
        ".f13d374e{grid-row-end:actions-start;}",
        ".f1fjo411{grid-column-end:actions-start;}"
    ],
    m: [
        [
            "@media screen and (max-width: 480px){.f6glcwc{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f1e3st1r{justify-self:stretch;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ]
    ]
});
const useDialogActionsStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(dialogActionsClassNames.root, styles.root, state.position === 'start' && styles.gridPositionStart, state.position === 'end' && styles.gridPositionEnd, state.fluid && state.position === 'start' && styles.fluidStart, state.fluid && state.position === 'end' && styles.fluidEnd, state.root.className);
    return state;
}; //# sourceMappingURL=useDialogActionsStyles.js.map

//# sourceMappingURL=useDialogActionsStyles.js.map